module.exports = __webpack_public_path__ + "media/images/guideline/G_01-30239522468dddcbbf175d34260de4a2.jpg";